var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "chevronRight_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.4 19.94c-.26 0-.52-.1-.71-.3a.987.987 0 0 1 .02-1.41l6.39-6.25-6.44-6.37a.987.987 0 0 1 0-1.41.987.987 0 0 1 1.41 0l7.15 7.08c.19.19.3.45.3.71s-.11.52-.3.71l-7.11 6.96c-.19.19-.45.29-.7.29z"
})));
export default SvgChevronRight;